import { useCallback, useEffect, useState } from "react"

import { Modal, Skeleton, Typography } from "antd"
import { useTranslation } from "react-i18next"

import FaqAccordion from "../../../../Components/FaqAccordion"

import styles from "./FaqStub.module.less"

const { Text } = Typography

// `loadItems` resolves to `{ title, text }[]`; each page brings its own FAQ and its own fallback.
export const FaqStub = ({ isMobile, open, onClose, description, loadItems }) => {
  const { t } = useTranslation()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchFaq = useCallback(
    async (controller) => {
      setLoading(true)
      try {
        const data = await loadItems()
        if (!controller.cancelled) setItems(data)
      } catch {
        // global error notification is already dispatched from the thunk
      } finally {
        if (!controller.cancelled) setLoading(false)
      }
    },
    [loadItems]
  )

  useEffect(() => {
    if (!open) return
    const controller = { cancelled: false }
    void fetchFaq(controller)
    return () => {
      controller.cancelled = true
    }
  }, [open, fetchFaq])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={t("FAQs")}
      width={640}
      centered={!isMobile}
      destroyOnHidden
      data-testid="faq-stub-modal"
    >
      <Text type="secondary" data-testid="faq-stub-description">
        {description}
      </Text>
      <div className={styles.accordionWrap} data-testid="faq-stub-accordion-wrap">
        {loading ? (
          <Skeleton active paragraph={{ rows: 10 }} data-testid="faq-stub-loading-skeleton" />
        ) : (
          <FaqAccordion items={items} />
        )}
      </div>
    </Modal>
  )
}
